import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as urlValues from '../oldReportsUrls'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import { appendToUrl, diffInMonths, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import {
    branchStockReportViewData,
    reportOption,
    GoodBalReprtPayType,
    reportGroupByOption,
    PDFHeaderColumnsWithoughtPayType,
    PDFHeaderColumnsWithPayType,
    PDFHeaderColumnsWithPayTypeFormattedLRNO,
    PDFHeaderColumnsWithPayTypeForBoth,
    PDFHeaderColumnsWithoughtPayTypeFormattedLRNO,
    PDFHeaderColumnsWithoughtPayTypeForBoth,
} from './constants'
import { updateAlertError } from '../../../../store/common/common_action'
import {
    getCargoSettingFilterData,
    getGoodsBalanceFilterData,
} from '../../../../store/reports/reports_action'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { useAtom, useSetAtom } from 'jotai'
import { urls } from '../../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, PostRequest } from '../../../common/api'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadPDF } from '../analysisReport/pdfAutotable'

const BranchStockReportNew = () => {
    const state = useSelector((state) => state)
    const { common, reports } = state
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [], Table : RoleRightsTable = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    const [roleRights] = RoleRightsTable
    let { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowViewAllBranchOfCityReport, AllowExportExcel } = { ...roleRightsData }
    const [companySettings] = useAtom(companySettingsAtom)
    const resolvedCompanySettings =
    !isEmpty(companySettings)
    ? companySettings
    : common?.companySettings?.[0] || {}
    let UseFormattedLRinReports = resolvedCompanySettings?.UseFormattedLRinReports||0
    let UseToPayAsCOD = resolvedCompanySettings?.UseToPayAsCOD||0

    const dispatch = useDispatch()
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [paymentType, setPaymentType] = useState(GoodBalReprtPayType?.[0])
    const [reportView, setReportView] = useState(branchStockReportViewData?.[0])
    const [reportOptions, setReportOptions] = useState(reportOption?.[0])
    const [reportGroupByOptions, setReportGroupByOptions] = useState(reportGroupByOption?.[0])
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [branchStockFilterData, setBranchStockFilterData] = useState({})

    // --new states--
    const [sourceCity, setSourceCity] = useState('')
    const [sourceCityData, setSourceCityData] = useState([])

    const [sourceBranch, setSourceBranch] = useState('')
    const [sourceBranchData, setSourceBranchData] = useState([])

    const [sourceBranchUser, setSourceBranchUser] = useState('')

    const [destinationCity, setDestinationCity] = useState('')
    const [destinationCityData, setDestinationCityData] = useState([])

    const [destinationBranch, setSelDestinationBranch] = useState('')
    const [destinationBranchdata, setSelDestinationBranchdata] = useState([])
    const reportName = 'Branch Stock'
     const [searchParams] = useSearchParams()
      let { loginData = {} } = useToken()
      let isFromUrl = false
    if (!loginData) {
        loginData = {}
        loginData.BusCrsCheckSum = Number(searchParams.get('CHK') || 0)
        loginData.intCompanyID = Number(searchParams.get('C') || 0)
        loginData.intBranchCityID = Number(searchParams.get('CT') || 0)
        loginData.intBranchID = Number(searchParams.get('B') || 0)
        loginData.intUserID = Number(searchParams.get('U') || 0)
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strCityName = searchParams.get('CTN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.IsBranchAdmin = Number(searchParams.get('IBA') || 0)
        loginData.IsMTPLAdmin = Number(searchParams.get('IMPTLA') || 0)
        loginData.IsAdmin = Number(searchParams.get('IA') || 0)
        AllowViewAllBranchReport = Number(searchParams.get('AllowViewAllBranchReport') || 0)
        AllowBranchInchargeRights = Number(searchParams.get('AllowBranchInchargeRights') || 0)
        AllowViewAllBranchOfCityReport = Number(searchParams.get('AllowViewAllBranchOfCityReport') || 0)
        AllowExportExcel = Number(searchParams.get('AllowExportExcel') || 0)
        UseToPayAsCOD = Number(searchParams.get('TPAsCOD')) || 0
        UseFormattedLRinReports = Number(searchParams.get('UFLR')) || 0
        isFromUrl = true
    }
 const { intCompanyID, strCompanyName, intUserID, IsAdmin, IsMTPLAdmin, IsBranchAdmin,  intBranchID } = loginData
 
 const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
        { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
        { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
        { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
        { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
        { field: 'reportView', header: 'Report View', textAlign: 'left' },
        { field: 'reportOptions', header: 'Report Options', textAlign: 'left' },
        { field: 'reportGroupBy', header: 'Report Group By', textAlign: 'left' },
    ]

    const criteriaData = {
        fromDate: moment(fromDate).format('DD-MM-YYYY') || '',
        toDate: moment(toDate).format('DD-MM-YYYY') || '',
        sourceCity: sourceCity?.City || '',
        sourceBranch: sourceBranch?.Branch || '',
        destinationCity: destinationCity?.DestinationCity || '',
        destinationBranch: destinationBranch?.DestinationBranch || '',
        paymentType: paymentType?.name || '',
        reportView: reportView?.view || '',
        reportOptions: reportOptions?.Option || '',
        reportGroupBy: reportGroupByOptions?.Option || '',
        dataType: 'entry',
    }
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)

    const filterData = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            const obj = {
                CompanyID: loginData?.intCompanyID,
                BranchID: loginData?.intBranchID,
                FromDate: moment(fromDate).format('YYYY-MM-DD'),
                ToDate: moment(toDate).format('YYYY-MM-DD'),
                UserID: loginData?.intUserID,
            }
            setLoader(true)
            GetRequest(urls.getGoodsBalanceFilter, obj)
                .then((res) => {
                    setLoader(false)
                    if (res.status == 'Success') {
                        setBranchStockFilterData(res)
                        if (res?.Data?.Table?.length >= 1) {
                            const SourceCity = [...new Set(res?.Data?.Table?.map((val) => ({ City: val.City, CityID: val.CityID }))),]
                            const SourceBranch = [...new Set(res?.Data?.Table?.map((val) => ({ Branch: val.Branch, BranchID: val.BranchID, CityID: val.CityID, }))),]
                            const DestinationCity = [...new Set(res?.Data?.Table?.map((val) => ({ DestinationCity: val.DestinationCity, DestinationcityID: val.DestinationcityID, CityID: val.CityID, }))),]
                            const updatedDestCity = DestinationCity.filter(val => val.DestinationcityID !== loginData.intBranchCityID)
                            const DestinationBranch = [...new Set(res?.Data?.Table?.map((val) => ({ DestinationBranch: val.DestinationBranch, DestinationBranchID: val.DestinationBranchID, DestinationcityID: val.DestinationcityID, }))),]
                            const updatedDestBranch = DestinationBranch.filter(val => val.DestinationBranchID !== loginData.intBranchID)

                            if (SourceCity?.length) SourceCity.unshift({ City: 'All Cities', CityID: 0 })
                            setSourceCityData([...SourceCity.filter((obj) => obj.CityID === loginData.intBranchCityID||obj.CityID === 0)])
                            setSourceCity(SourceCity.find((obj) => obj.CityID === loginData.intBranchCityID) || '')
                            if (SourceBranch.length) SourceBranch.unshift({ Branch: 'All Branches', BranchID: 0, CityID: loginData.intBranchCityID })
                            setSourceBranchData([...SourceBranch.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                            setSourceBranch(SourceBranch.find((obj) => obj.BranchID === loginData.intBranchID) || SourceBranch?.[0] || '')
                            setDestinationCityData([{ DestinationCity: 'All Cities', DestinationcityID: 0 }, ...updatedDestCity])
                            const destinationBranchOptions = getDestinationBranchOptions(updatedDestBranch)
                            setSelDestinationBranchdata(destinationBranchOptions)
                            setDestinationCity({ DestinationCity: 'All Cities', DestinationcityID: 0 })
                            setSelDestinationBranch(destinationBranchOptions[0] || '')
                        } else {
                            setSourceCityData([])
                            setSourceBranchData([])
                            setDestinationCityData([])
                            setSelDestinationBranchdata([])
                            setSelDestinationBranch('')
                        }
                    } else {
                        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
                    }
                })
                .catch((err) => {
                    setLoader(false)
                })
        }
    }

    const reset = () => {
        setFromDate(moment(new Date()))
        setToDate(moment(new Date()))
        setSourceCity(' ')
        setSourceBranch(' ')
        setSourceBranchUser(' ')
        setDestinationCity(' ')
        setSelDestinationBranch(' ')
        setPaymentType([paymentModesWithAll?.[0]])
        setReportView(branchStockReportViewData?.[-1])
    }

    useEffect(() => {
        focusElemnt('fromDate')
    }, [])
   
    useEffect(() => {
        if (!isEmpty(roleRightsData)  && intUserID) {
            setDisableBtn(
                !(
                    AllowViewAllBranchReport ||
                    AllowBranchInchargeRights ||
                    loginData?.IsBranchAdmin ||
                    loginData?.IsMTPLAdmin ||
                    loginData?.IsAdmin
                )
            )
            setDisableExcel(!AllowExportExcel)
        }
    }, [roleRightsData, intUserID])
    const getFilteredData = (branchStockTableData) => {
        if (reportGroupByOptions?.Option === 'With Payment Type') {
            if (branchStockTableData?.Data?.Table1?.length > 0) {
                let data = branchStockTableData?.Data?.Table1
                const filtData = data.map((item) => ({
                    ...item,
                    dataType: 'entry',
                    Qty: `${item.TotalQuantity} ${item.ItemDetails === null ? '' : item.ItemDetails}`,
                }))
                return filtData
            }
        } else {
            if (branchStockTableData?.Data?.Table?.length > 0) {
                let data = branchStockTableData?.Data?.Table
                const filtData = data.map((item, index) => ({
                    ...item,
                    dataType: 'entry',
                    Sr: index + 1,
                    Qty: `${item.TotalQuantity} ${item.ItemDetails === null ? '' : item.ItemDetails}`,
                }))
                return filtData
            }
        }
        return []
    }
    const groupBy = (array, key) => {
        return array.reduce((result, currentValue) => {
            ; (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue)
            return result
        }, {})
    }
    const groupTableData = (tablesData) => {
        const filterData = tablesData.filter((item) => item.TYPE === reportOptions?.optionType)
        const freightTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
        const cartageTotal = filterData.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
        const hamaliTotal = filterData.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
        const netAmountTotal = filterData.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)
        const totalRow = {
            dataType: 'total',
            PaymentType: 'Total:',
            Sr: '',
            LRNO: '',
            BookingDate: '',
            DestBranch: '',
            Sender: '',
            RecName: '',
            Qty: ' ',
            ItemDetails: '',
            TotalFreight: freightTotal,
            Cartage: cartageTotal,
            Hamali: hamaliTotal,
            TotalNet: netAmountTotal,
            colSpan: { Sr: 8 },
            align: { Sr: 'right' }
        }
        const tableData = [...filterData, totalRow]
        const groupedData = groupBy(filterData, 'PaymentType')

        const groupData = []

        Object.entries(groupedData).forEach(([PaymentType, items]) => {
            // Calculate totals for each group
            const freightTotal = items.reduce((a, b) => Number(a) + Number(b.TotalFreight), 0)
            const cartageTotal = items.reduce((a, b) => Number(a) + Number(b.Cartage), 0)
            const hamaliTotal = items.reduce((a, b) => Number(a) + Number(b.Hamali), 0)
            const netAmountTotal = items.reduce((a, b) => Number(a) + Number(b.TotalNet), 0)

            // Push group title (optional)
            // groupData.push({ isGroupHeader: true, type });
            groupData.push({
                dataType: 'subHeader',
                Sr: `${PaymentType} : ${reportOptions?.Option}`,
                colSpan: { Sr: 11 },
                align: { Sr: 'left' },
            })

            // Push group items
            groupData.push(...items)

            // Push total row for group
            groupData.push({
                dataType: 'total',
                PaymentType: 'Total:',
                Sr: '',
                LRNO: '',
                BookingDate: '',
                DestBranch: '',
                Sender: '',
                RecName: '',
                Qty: ' ',
                ItemDetails: '',
                TotalFreight: freightTotal,
                Cartage: cartageTotal,
                Hamali: hamaliTotal,
                TotalNet: netAmountTotal,
                colSpan: { Sr: 8 },
                align: { Sr: 'right' }
            })
        })
        let serialNumber = 1 // Initialize serial number counter

        const finalTableData = groupData.map((row) => {
            if (row.dataType !== 'subHeader' && row.dataType !== 'total') {
                return { ...row, Sr: serialNumber++ } // Assign Sr and increment counter
            }
            return row // Keep other rows unchanged
        })
        if (reportGroupByOptions?.Option !== 'With Payment Type') {
            return tableData
        } else {
            return finalTableData
        }

    }
    const getMainHeader = (columns = []) =>
        columns.map((column) => {
            const header = column.header || column.headerName || column.exportHead || ''
            return {
                ...column,
                header,
                exportHead: column.exportHead || header,
                align: column.align || column.textAlign || 'left',
                weight: column.weight ?? 80,
            }
        })

    const ensureHeaderColumnAfter = (columns = [], referenceField, newColumn) => {
        const updatedColumns = [...columns]
        const referenceIndex = updatedColumns.findIndex((column) => column.field === referenceField)

        if (referenceIndex === -1) {
            return updatedColumns
        }

        const existingIndex = updatedColumns.findIndex((column) => column.field === newColumn.field)

        if (existingIndex !== -1) {
            const [existingColumn] = updatedColumns.splice(existingIndex, 1)
            const nextReferenceIndex = updatedColumns.findIndex((column) => column.field === referenceField)
            updatedColumns.splice(nextReferenceIndex + 1, 0, existingColumn)
            return updatedColumns
        }

        updatedColumns.splice(referenceIndex + 1, 0, newColumn)
        return updatedColumns
    }

    const getReportHeaders = () => {
        const selectedHeaders =
            reportGroupByOptions?.Option === 'With Payment Type'
                ? UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
                    ? PDFHeaderColumnsWithPayType
                    : UseFormattedLRinReports === 2
                        ? PDFHeaderColumnsWithPayTypeFormattedLRNO
                        : PDFHeaderColumnsWithPayTypeForBoth
                : UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
                    ? PDFHeaderColumnsWithoughtPayType
                    : UseFormattedLRinReports === 2
                    ? PDFHeaderColumnsWithoughtPayTypeFormattedLRNO
                        : PDFHeaderColumnsWithoughtPayTypeForBoth

        const normalizedHeaders = selectedHeaders.map((column) =>
            column.field === 'ItemDetails'
                ? {
                    ...column,
                    headerName: 'Item Type',
                    exportHead: 'Item Type',
                }
                : column
        )
        const orderedHeaders = ensureHeaderColumnAfter(normalizedHeaders, 'ItemDetails', {
            headerName: 'Payment Type',
            exportHead: 'Payment Type',
            field: 'PaymentType',
            xlCol: { dataType: 'string', dataFormatter: null },
            align: 'left',
            isSortIcon: true,
        })

        return getMainHeader(orderedHeaders)
    }
    const getReportPayload = (groupedData, isPdf) => {
        const mainHeader = getReportHeaders()
        const reportTitle =
            reportOptions?.optionId === 0
                ? 'Branch Stock Report (Booked - Pending Dispatch)'
                : 'Branch Stock Report (Received - Pending Delivery)'
        if (isPdf === true) {
            return downloadPDF({
                reportName: reportTitle,
                 criteriaHeaders,
                criteriaData: [criteriaData],
                 tableData: groupedData,
                visibleColumns: mainHeader,
                loginData,
                hideHeader: false
            })
        } else {
            return {
                reportName: reportTitle,
                criteriaHeaders,
                criteriaData: [criteriaData],
                tableData: groupedData,
                mainHeader,
                serialNokey: 'Sr',
            }
        }
    }
    const openViewReport = (reportPayload) => {
        const rid = Date.now().toString()

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
    }
    const getDestinationBranchOptions = (branches = []) =>
        branches.length
            ? [{ DestinationBranch: 'All Branch', DestinationBranchID: 0 }, ...branches]
            : []
    const handleClick1 = async (isPdf = false) => {
        if (sourceCity == '' || sourceCity == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Source City', nextId: '' }))
        } else if (destinationBranch == '' || destinationBranch == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Destination Branch', nextId: '' }))
        } else if (!sourceBranch?.Branch) {
            dispatch(updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' }))
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                SelectedBranchID: sourceBranch?.BranchID || 0,
                DestinationCityID: destinationCity?.DestinationcityID || 0,
                DestinationBranchID: destinationBranch?.DestinationBranchID || 0,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                Mode: reportOptions?.optionId,
                PaymentTypeID: paymentType?.typeId,
                IsOnline: reportView?.id,
            }
            setLoader(true)
            try {
                const res = await GetRequest(urls.getBranchStockTableData, body)
                setLoader(false)
                if (res?.status !== 'Success') {
                    setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                    return
                }

                const tablesData = getFilteredData(res)
                const groupedData = groupTableData(tablesData)

                if (!Array.isArray(groupedData) || groupedData.length === 0) {
                   setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                   return
                }

                if (isPdf) {
                    getReportPayload(groupedData, true)
                } else {
                    openViewReport(getReportPayload(groupedData, false))
                }
            } catch (error) {
                setLoader(false)
                setAlert({ show: true, msg: error?.message || 'Branch stock report generation failed', nextId: '' })
                return
            } 
        }
    }

    const handleClick2 = () => {
        if (sourceCity == '' || sourceCity == ' ') {
            dispatch(updateAlertError({ show: true, msg: 'Select Source City', nextId: '' }))
        } else if (!sourceBranch?.Branch) {
            dispatch(updateAlertError({ show: true, msg: 'Select Source Branch', nextId: '' }))
        } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
            dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
        } else {
            let url = urlValues.branchStockReport
            const urlData = urlValues.branchStockReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.SelBranchID = sourceBranch?.BranchID || 0
            urlData.DestCityID = destinationCity?.DestinationcityID || 0
            urlData.DestBranchID = destinationBranch?.DestinationBranchID || 0
            urlData.FromDate = moment(fromDate).format('YYYY-MM-DD')
            urlData.ToDate = moment(toDate).format('YYYY-MM-DD')
            urlData.Status = 0
            urlData.isSummaryOnly = 0
            urlData.IsOnline = -1
            urlData.intAllowExportExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }

    const handleReportOption = (val) => {
        setReportOptions(val)
        if (val.optionId === 0) {
            if (branchStockFilterData?.Data?.Table?.length >= 1) {
                const SourceCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ City: val.City, CityID: val.CityID }))),]
                const SourceBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ Branch: val.Branch, BranchID: val.BranchID, CityID: val.CityID, }))),]
                const DestinationCity = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationCity: val.DestinationCity, DestinationcityID: val.DestinationcityID, CityID: val.CityID, }))),]
                const updatedDestCity = DestinationCity.filter(val => val.DestinationcityID !== loginData.intBranchCityID)
                const DestinationBranch = [...new Set(branchStockFilterData?.Data?.Table?.map((val) => ({ DestinationBranch: val.DestinationBranch, DestinationBranchID: val.DestinationBranchID, DestinationcityID: val.DestinationcityID, }))),]
                const updatedDestBranch = DestinationBranch.filter(val => val.DestinationBranchID !== loginData.intBranchID)

                if (SourceCity?.length) SourceCity.unshift({ City: 'All Cities', CityID: 0 })
                setSourceCityData([...SourceCity.filter((obj) => obj.CityID === loginData.intBranchCityID || obj.CityID === 0)])
                setSourceCity(SourceCity.find((obj) => obj.CityID === loginData.intBranchCityID) || '')
                if (SourceBranch.length) SourceBranch.unshift({ Branch: 'All Branches', BranchID: 0, CityID: loginData.intBranchCityID })
                setSourceBranchData([...SourceBranch.filter((obj) => obj.CityID === loginData.intBranchCityID)])
                setSourceBranch(SourceBranch.find((obj) => obj.BranchID === loginData.intBranchID) || SourceBranch?.[0] || '')
                setDestinationCityData([{ DestinationCity: 'All Cities', DestinationcityID: 0 }, ...updatedDestCity])
                setDestinationCity({ DestinationCity: 'All Cities', DestinationcityID: 0 })
                const destinationBranchOptions = getDestinationBranchOptions(updatedDestBranch)
                setSelDestinationBranchdata(destinationBranchOptions)
                setSelDestinationBranch(destinationBranchOptions[0] || '')
            }
        } else {
            if (branchStockFilterData?.Data?.Table?.length >= 1) {
                const SourceCity = [
                    ...new Map(
                        branchStockFilterData?.Data?.Table?.map((val) => [
                            val.DestinationcityID,
                            { City: val.DestinationCity, CityID: val.DestinationcityID },
                        ])
                    ).values(),
                ];

                const updatedSourceCity = SourceCity?.filter(
                    (item) => item.CityID !== loginData.intBranchCityID
                );

                setSourceCityData([{ City: 'All Cities', CityID: 0 }, ...updatedSourceCity]);
                setSourceCity({ City: 'All Cities', CityID: 0 });


                // Source Branch (from DestinationBranch)
                const SourceBranch = [
                    ...new Map(
                        branchStockFilterData?.Data?.Table?.map((val) => [
                            val.DestinationBranchID,
                            {
                                Branch: val.DestinationBranch,
                                BranchID: val.DestinationBranchID,
                                CityID: val.DestinationcityID,
                            },
                        ])
                    ).values(),
                ];

                const updatedSourceBranch = SourceBranch?.filter(
                    (item) => item.BranchID !== loginData.intBranchID
                );

                setSourceBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...updatedSourceBranch]);
                setSourceBranch({ Branch: 'All Branches', BranchID: 0 });


                // ===== DESTINATION should now come from SOURCE fields =====

                // Destination City (from City)
                const DestinationCity = [
                    ...new Map(
                        branchStockFilterData?.Data?.Table?.map((val) => [
                            val.CityID,
                            {
                                DestinationCity: val.City,
                                DestinationcityID: val.CityID,
                                CityID: val.CityID,
                            },
                        ])
                    ).values(),
                ];

                setDestinationCityData(
                    DestinationCity.filter((obj) => obj.DestinationcityID === loginData.intBranchCityID)
                );

                setDestinationCity(
                    DestinationCity.filter((obj) => obj.DestinationcityID === loginData.intBranchCityID)?.[0] || ''
                );


                // Destination Branch (from Branch)
                const DestinationBranch = [
                    ...new Map(
                        branchStockFilterData?.Data?.Table?.map((val) => [
                            val.BranchID,
                            {
                                DestinationBranch: val.Branch,
                                DestinationBranchID: val.BranchID,
                                DestinationcityID: val.CityID,
                            },
                        ])
                    ).values(),
                ];

                const selectedDestinationBranches = DestinationBranch.filter(
                    (obj) => obj.DestinationBranchID === loginData.intBranchID
                );

                setSelDestinationBranchdata(selectedDestinationBranches);
                setSelDestinationBranch(selectedDestinationBranches[0] || '');


            }
        }
    }

   const selectedSourceCity = (obj) => {
    setSourceCity(obj)

    let filterSourceBranch = []

    // ✅ get allowed city ids from dropdown list
    const allowedCityIDs = sourceCityData
        ?.filter((c) => c.CityID !== 0)
        ?.map((c) => c.CityID)

    if (reportOptions?.optionId === 0) {
        // NORMAL FLOW
        filterSourceBranch =
            branchStockFilterData?.Data?.Table
                ?.filter((val) => {
                    const cityMatch =
                        obj?.CityID === 0
                            ? allowedCityIDs.includes(val.CityID)  // ✅ FIX
                            : val.CityID === obj?.CityID

                    return (
                        cityMatch &&
                        val.BranchID !== destinationBranch?.DestinationBranchID
                    )
                })
                .map((val) => ({
                    Branch: val.Branch,
                    BranchID: val.BranchID,
                    CityID: val.CityID,
                })) || []
    } else {
        // SWAPPED FLOW
        filterSourceBranch =
            branchStockFilterData?.Data?.Table
                ?.filter((val) => {
                    const cityMatch =
                        obj?.CityID === 0
                            ? allowedCityIDs.includes(val.DestinationcityID) // ✅ FIX
                            : val.DestinationcityID === obj?.CityID

                    return (
                        cityMatch &&
                        val.DestinationBranchID !== destinationBranch?.DestinationBranchID
                    )
                })
                .map((val) => ({
                    Branch: val.DestinationBranch,
                    BranchID: val.DestinationBranchID,
                    CityID: val.DestinationcityID,
                })) || []
    }

    setSourceBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...filterSourceBranch])
    setSourceBranch(filterSourceBranch?.[0] || '')
}

   const selectedDestCity = (obj) => {
    setDestinationCity(obj)

    let filterDestBranch = []

    // ✅ allowed destination cities from dropdown
    const allowedDestCityIDs = destinationCityData
        ?.filter((c) => c.DestinationcityID !== 0)
        ?.map((c) => c.DestinationcityID)

    if (reportOptions?.optionId === 0) {
        // NORMAL FLOW
        filterDestBranch =
            branchStockFilterData?.Data?.Table
                ?.filter((val) => {
                    const cityMatch =
                        obj?.DestinationcityID === 0
                            ? allowedDestCityIDs.includes(val.DestinationcityID) // ✅ FIX
                            : val.DestinationcityID === obj?.DestinationcityID

                    return (
                        cityMatch &&
                        val.DestinationBranchID !== sourceBranch?.BranchID
                    )
                })
                .map((val) => ({
                    DestinationBranch: val.DestinationBranch,
                    DestinationBranchID: val.DestinationBranchID,
                    DestinationcityID: val.DestinationcityID,
                })) || []
    } else {
        // SWAPPED FLOW
        filterDestBranch =
            branchStockFilterData?.Data?.Table
                ?.filter((val) => {
                    const cityMatch =
                        obj?.DestinationcityID === 0
                            ? allowedDestCityIDs.includes(val.CityID) // ✅ FIX
                            : val.CityID === obj?.DestinationcityID

                    return (
                        cityMatch &&
                        val.BranchID !== sourceBranch?.DestinationBranchID
                    )
                })
                .map((val) => ({
                    DestinationBranch: val.Branch,
                    DestinationBranchID: val.BranchID,
                    DestinationcityID: val.CityID,
                })) || []
    }

    const destinationBranchOptions = getDestinationBranchOptions(filterDestBranch)

    setSelDestinationBranchdata(destinationBranchOptions)
    setSelDestinationBranch(destinationBranchOptions[0] || '')
}
    const rightsRow = RoleRightsTable?.find(r => r.BookingRightsID === 1) || {}
    const paymentDropdownData = GoodBalReprtPayType?.filter((val) => rightsRow[val.uniqKey] === 1 || val.uniqKey === 'All').map((item) => {
        if (UseToPayAsCOD === 1) {
            switch (item.typeId) {
                case 2:
                    return { ...item, name: "COD" };
                case 7:
                    return { ...item, name: "COD Manual" };
                case 9:
                    return { ...item, name: "COD DDDV" };
                case 4:
                    return null;
                default:
                    return item;
            }
        }
        return item;
    })
        .filter(Boolean);
    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                 {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                 {isFromUrl ? <></> :<ReportHeading reportName={reportName} />}
                <Box sx={sx.reportFlex}>
                    {!isFromUrl && (
                        <>
                    <Item sx={sx.itemsxGrow}>
                        <DropDownOA
                            id={id.selectCompnay}
                            label={lb.select_company}
                            defaultvalue={loginData.strCompanyName}
                            disabled={true}
                            // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
                            width="100%"
                        />{' '}
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            disabled={true}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            id={id.goButton}
                            className="btn btn-primary"
                        >
                            GO
                        </Button>
                    </Item>
                        </>
                    )}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}  className="input--container bookingDatePicker">
                        <Datepicker
                            name={'from_collection_date'}
                            value={fromDate}
                            label={'From Date'}
                            id={id.fromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt(id.toDate)
                            }}
                            width="100%"
                            dateDiff={730}
                        />
                    </Item>
                    <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx}  className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Date'}
                            value={toDate}
                            id={id.toDate}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('goodGoBtn')
                            }}
                            width="100%"
                            dateDiff={730}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            id="goodGoBtn"
                            onKeyDown={(e) => navigation3(e, 'sourceBranch', id.toDate, () => filterData())}
                            variant="contained"
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                            onClick={filterData}
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: '235px' }}>
                        <DropDownOA
                            id={id.anReportOptions}
                            data={reportOption || []}
                            defaultvalue={reportOptions?.Option || ''}
                            width="100%"
                            searchPlaceholder={`Search By Report Options`}
                            label={'Report Options'}
                            tabIndex="2"
                            dataKey={`Option`}
                            idKey={`optionId`}
                            listWidth="200px"
                            onSelect={(value) => {
                                handleReportOption(value)
                            }}
                            nextId={id.anReportGroupByOptions}
                            prevId={id.gbView}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label="Source City"
                            id="sourceCity"
                            nextId={'destinationBranch'}
                            prevId={'sourceBranch'}
                            defaultvalue={sourceCity?.City || ''}
                            data={removeDuplicatesFromArray(sourceCityData, 'CityID')}
                            dataKey={`City`}
                            idKey={`CityID`}
                            onSelect={(obj) => selectedSourceCity(obj)}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label="Source Branch"
                            id="sourceBranch"
                            nextId={'destinationCity'}
                            prevId={'goodGoBtn'}
                            disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
                            data={removeDuplicatesFromArray(sourceBranchData, 'BranchID') || []}
                            defaultvalue={sourceBranch?.Branch || ""}
                            dataKey={`Branch`}
                            idKey={`BranchID`}
                            onSelect={(val) => { setSourceBranch(val) }}
                            width="100%"
                            listWidth={'250px'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            label="Destination City"
                            id="destinationCity"
                            nextId={'destinationBranch'}
                            prevId={'sourceBranch'}
                            defaultvalue={destinationCity?.DestinationCity || destinationCity}
                            data={removeDuplicatesFromArray(destinationCityData, 'DestinationcityID') || []}
                            dataKey={`DestinationCity`}
                            idKey={`DestinationcityID`}
                            onSelect={(obj) => selectedDestCity(obj)}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            key={`destinationBranch-${destinationBranch?.DestinationBranch || 'empty'}-${destinationBranchdata.length}`}
                            label="Destination Branch"
                            id="destinationBranch"
                            nextId={id.gbPaymentType}
                            prevId={'destinationCity'}
                            defaultvalue={destinationBranch?.DestinationBranch || destinationBranch}
                            data={removeDuplicatesFromArray(destinationBranchdata, 'DestinationBranchID') || []}
                            dataKey={`DestinationBranch`}
                            idKey={`DestinationBranchID`}
                            onSelect={(obj) => { setSelDestinationBranch(obj) }}
                            width="100%"
                            listWidth={'250px'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: '205px' }}>
                        <DropDownOA
                            id={id.gbPaymentType}
                            data={paymentDropdownData || []}
                            defaultvalue={paymentType?.name}
                            width="100%"
                            searchPlaceholder={`Search By Payment Type`}
                            label={'Payment Type'}
                            tabIndex="2"
                            dataKey={`name`}
                            idKey={`typeId`}
                            onSelect={(value) => {
                                setPaymentType(value)
                            }}
                            nextId={id.gbView}
                            prevId={'destinationBranch'}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: '205px' }}>
                        <DropDownOA
                            id={id.gbView}
                            defaultvalue={reportView?.view}
                            data={branchStockReportViewData}
                            width="100%"
                            searchPlaceholder={`Search By View`}
                            label={'Report View'}
                            tabIndex="2"
                            dataKey={`view`}
                            idKey={`id`}
                            onSelect={(value) => setReportView(value)}
                            nextId={id.anReportOptions}
                            prevId={id.gbPaymentType}
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: '235px' }}>
                        <DropDownOA
                            id={id.anReportGroupByOptions}
                            data={reportGroupByOption || []}
                            defaultvalue={reportGroupByOptions?.Option || ''}
                            width="100%"
                            searchPlaceholder={`Search By Report Group By`}
                            label={'Report Group By'}
                            tabIndex="2"
                            dataKey={`Option`}
                            idKey={`optionId`}
                            listWidth="200px"
                            onSelect={(value) => {
                                setReportGroupByOptions(value)
                            }}
                            nextId={id.reportmainButton}
                            prevId={id.anReportOptions}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom: '10px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.reportmainButton}>
                            DOWNLOAD PDF
                        </Button> :
                        <>
                    <Item
                        sx={sx.itemsx}
                        style={{ cursor: 'pointer' }}
                        onKeyDown={(e) =>
                            navigation3(e, id.fromDate, id.anReportGroupByOptions, ()=>handleClick1(false))}
                    >
                        <SplitButton
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            id1={id.reportmainButton}
                            prevID={id.summaryCheck}
                            onClick1={()=>handleClick1(false)}
                            onClick2={handleClick2}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                        <RefreshSvg width={'24px'} height={'24px'} />
                    </Item></>}
                </Box>
            </Item>
        </>
    )
}

export default BranchStockReportNew
